import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { File360Error } from './error.model';
import { File360Resources } from './resources';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export const enum HttpStatus {
  ConnectionRefused = 0,
  Unauthorized = 401,
};

@Injectable()
export class ErrorHandlerService {

  lastErrorMessage: string = "";

  constructor(private log: LogService) { }

  handleError(error: any) {

    //Log the error and return an Observable of type File360Error (cast to "any")
    //with the typed Error object. THe caller can access the status code and message.

    if (error.error instanceof ErrorEvent) {
      console.log('ErrorHandlerService : logFile360Error() - ErrorEvent');
      let f360err: File360Error = new File360Error(0, error.error.message, error.error);
      this.lastErrorMessage = f360err.Message;
      this.log.logError(f360err);
      return throwError(f360err);
    } else if (error.error instanceof Error) {
      console.log('ErrorHandlerService : logFile360Error() : Error');
      let f360err: File360Error = new File360Error(error.status, error.message, error);
      this.lastErrorMessage = f360err.Message;
      this.log.logError(f360err);
      return throwError(f360err);
    } else if (error.error instanceof ProgressEvent) {
      console.log('ErrorHandlerService : logFile360Error() : ProgressEvent');
      let f360err: File360Error = new File360Error(HttpStatus.ConnectionRefused,
        File360Resources.ERR_SystemUnavailable,
        new Error(File360Resources.ERR_SystemUnavailable));
      this.lastErrorMessage = f360err.Message;
      this.log.logError(f360err);
      return throwError(f360err);
    } else if (error.error instanceof HttpErrorResponse) {
      console.log('ErrorHandlerService : File360Error() : HttpErrorResponse');
      let f360err: File360Error = new File360Error(error.status, error.error, error);
      this.lastErrorMessage = f360err.Message;
      this.log.logError(f360err);
      return throwError(f360err);
    } else if (error instanceof HttpErrorResponse) {
      console.log('ErrorHandlerService : File360Error() : HttpErrorResponse');
      let f360err: File360Error = new File360Error(error.status, error.error, error);
      this.lastErrorMessage = f360err.Message;
      this.log.logError(f360err);
      return throwError(f360err);
    } else {
      console.log('ErrorHandlerService : File360Error() : ' + File360Resources.ERR_Unhandled);
      let f360err: File360Error = new File360Error(error.status, error.error, error);
      this.lastErrorMessage = f360err.Message;
      this.log.logError(f360err);
      return throwError(f360err);
    }
  }
}